/**
 * Волна 35: стройка с учетом риска потерять город (признак B, гейт
 * isPreW35BuildRiskPlayer) и резерв монет армейской фазы бонусных ботов
 * (признак S, гейт isPreW35ArmyReservePlayer). Константы и чистые формулы;
 * состояние игры читает decideConstructionStep (и decidePolicyStep — резерв).
 *
 * Зачем B. Разбор реплеев прода (замечания игроков высокого рейтинга, архив
 * 2026-10-26): боты вкладывали монеты в города, которые теряли в тот же или
 * следующий раунд. Персей R8 — квартал и гильдия в 2,-1 при держателе d20(9)
 * против ожидаемых 37.7 урона; Рамсес R8–R9 — 35 монет в центр 0,0, отданный
 * уже за 17 очков вместо 7; Катон R9 — новый город 4,4 в 2 клетках от d6(5)
 * противника, потерян в тот же раунд. Оценка постройки считала доход ×
 * оставшиеся раунды так, будто город наверняка останется своим, а модель
 * угрозы (evaluation/cityCaptureThreat) шла только на резервы монет.
 *
 * Как устроено. Ожидаемая ценность постройки в своем городе — ее оценка ×
 * вероятность удержать город МИНУС потеря при захвате: каждое строение города
 * прибавляет захватчику очко (calcCityWinPoints), а монеты на него пропадают
 * вместе с городом. Множители — грубые вероятности удержания по уровню
 * угрозы; в разборе проды пустой город с угрозой этого раунда брали в 9 из 10
 * случаев, с угрозой следующего — в половине.
 */

// --- B: постройка в своем городе (квартал, ферма, казарма, спецстроения,
// разведка рудника гномов; крепость — оборонное строение, ее не касается)

// Множители сверены с разбором архива прода (garrisonStats, 96 тыс. записей
// «город × ход войны»): пустой город с угрозой этого раунда брали в ~90%,
// с угрозой следующего раунда при враге в ≤2 клетках — в 55–59% (с
// держателем — в 31–36%), а без угрозы при враге в 3–4 клетках — лишь в
// 14–15% за два раунда. Поэтому без угрозы модели (уровень NONE) стройку не
// режет и перевес противника рядом: горизонт «два хода» — дело модели угрозы
//
// Угроза захвата в этом раунде, а держателя, переживающего ожидаемый урон, нет
export const BUILD_RISK_THIS_ROUND_FACTOR = 0.15;
// Угроза следующего раунда (дотянется ходящий раньше или с +1 снабжения):
// на кварталах города нет ни одного своего отряда / держатель есть
export const BUILD_RISK_NEXT_ROUND_FACTOR = 0.5;
export const BUILD_RISK_NEXT_ROUND_HELD_FACTOR = 0.7;
// Перевес противника в отрядах в радиусе 3 от центрального квартала города
// (тот же замер, что у checkIfEnemyOutweighsNear волны 22) при угрозе этого
// или следующего раунда — держатель такую армию не сдержит
export const BUILD_RISK_OUTWEIGHED_FACTOR = 0.3;
// Сколько единиц оценки стройки стоит очко, отданное захватчику вместе с
// городом (оценки стройки — в очках: монеты в них переводятся по курсу
// фракции, обычно 2:1)
export const BUILD_RISK_CAPTURE_GIFT_PER_WIN_POINT = 1;

// --- B: место нового города (центральный квартал) — для всех ботов.
// Синтетический город из одной клетки проходит ту же модель угрозы, что и
// свои города: угроза этого раунда без своего отряда на клетке (или с
// держателем, который не переживет урон) и угроза следующего раунда без отряда
export const NEW_CITY_SITE_THIS_ROUND_FACTOR = 0.2;
export const NEW_CITY_SITE_NEXT_ROUND_FACTOR = 0.6;

/**
 * Вероятность удержать свой город для стройки в нем (1 — риска нет).
 * isThisRound/isNextRound — уровень угрозы модели бота; hasHolders — на
 * кварталах есть свои отряды; hasSurvivingHolder — держатели переживают
 * ожидаемый урон ходящих после бота; isOutweighed — перевес противника рядом.
 */
export const calcCityBuildSurvivalFactor = ({
  isThisRound, isNextRound, hasHolders, hasSurvivingHolder, isOutweighed,
}) => {
  if (!isThisRound && !isNextRound) {
    return 1;
  }
  let factor = 1;
  if (isThisRound) {
    factor = hasSurvivingHolder ? 1 : BUILD_RISK_THIS_ROUND_FACTOR;
  } else {
    factor = hasHolders ? BUILD_RISK_NEXT_ROUND_HELD_FACTOR : BUILD_RISK_NEXT_ROUND_FACTOR;
  }
  if (isOutweighed) {
    factor = Math.min(factor, BUILD_RISK_OUTWEIGHED_FACTOR);
  }
  return factor;
};

/** Вероятность удержать новый город на месте будущего центрального квартала. */
export const calcNewCitySiteSurvivalFactor = ({isThisRound, isNextRound, hasSurvivingHolder, hasHolders}) => {
  if (isThisRound && !hasSurvivingHolder) {
    return NEW_CITY_SITE_THIS_ROUND_FACTOR;
  }
  if (isNextRound && !hasHolders) {
    return NEW_CITY_SITE_NEXT_ROUND_FACTOR;
  }
  return 1;
};

/**
 * Потеря при захвате города в единицах оценки стройки: очки строения, которые
 * получит захватчик, и монеты, ушедшие в строение (в конце партии монеты —
 * очки по курсу фракции, coinsToPoints).
 */
export const calcCaptureLoss = (giftWinPoints, priceCoins, coinsToPoints) => (
  giftWinPoints * BUILD_RISK_CAPTURE_GIFT_PER_WIN_POINT + (priceCoins || 0) * coinsToPoints
);

// Постройка под угрозой с ожидаемой пользой меньше очка не строится: это шум
// модели, а не повод нести монеты в город, который вот-вот захватят (иначе
// жадный план добивал действия кварталами и казармами по 0.1–1 в обреченном
// городе: Персей R8, Рамсес R8)
export const BUILD_RISK_MIN_EXPECTED_SCORE = 1;

/**
 * Оценка постройки с учетом риска: ценность × вероятность удержания минус
 * потеря при захвате × вероятность захвата; ниже BUILD_RISK_MIN_EXPECTED_SCORE —
 * ноль. Обычные оценки стройки цену не вычитают — при большой ценности она
 * мала на ее фоне; под угрозой ценность режется множителем, и цена
 * становится сравнимой с ней.
 */
export const applyBuildSurvivalFactor = (score, factor, captureLoss) => {
  if (factor >= 1) {
    return score;
  }
  const expectedScore = score * factor - (1 - factor) * captureLoss;
  return expectedScore >= BUILD_RISK_MIN_EXPECTED_SCORE ? expectedScore : 0;
};

// --- S: резерв армейской фазы (C10 волны 33) не блокирует всю стройку.
//
// C10 держит монеты на два предпочтительных отряда (кап 16), и при меньшем
// запасе стройка не шла вовсе. Архив прода (явные LARGE/GREAT с пакетом
// «сильных городов», R2–8, с 2026-10-04, 3814 ходов стройки): 135 ходов без
// единой постройки при монетах ниже «резерв + 2»; у Сципиона (элементали)
// 0 построек за R2–8 при 9–15 монетах, d12 шесть раундов стоял вне снабжения.
// При этом в 55% таких ходов после фазы войны у бота оставалась цена отряда
// и больше — резерв лежал мертвым грузом. Сравнение вариантов на тех же
// ходах (верхняя оценка монет, отнятых у найма, в среднем на ход):
//  - резерв не больше одной цены отряда: разблокировано 135 из 135, −2.4;
//  - резерв только при армии < 2 отрядов или угрозе городу: 88 из 135, −2.7;
//  - вторая цена отряда только из монет сверх минимального бюджета стройки
//    (выбран): 135 из 135, −1.7; на всех ходах армейской фазы резерв ниже
//    прежнего в среднем лишь на 0.7 монеты — богатый бот по-прежнему держит
//    два отряда, а у бедного стройка получает бюджет на ферму или дорогу
//    снабжения, а резерв не опускается ниже цены одного отряда.
export const ARMY_PHASE_MIN_BUILD_BUDGET = 4;

/**
 * Резерв армейской фазы с минимальным бюджетом стройки: не больше прежнего
 * C10 (armyPhaseReserve), не меньше цены одного предпочтительного отряда,
 * а сверх нее — только из монет, остающихся после минимального бюджета.
 */
export const calcArmyPhaseReserveWithBuildBudget = (armyPhaseReserve, preferredUnitPrice, coins) => (
  Math.min(armyPhaseReserve, Math.max(preferredUnitPrice, coins - ARMY_PHASE_MIN_BUILD_BUDGET))
);

/**
 * Монеты игрока на начало его хода стройки: текущие плюс цены построек,
 * уже размещенных в этой фазе. Бот пересчитывает план каждый тик — бюджет от
 * текущих монет таял бы с каждой постройкой, и минимальный бюджет стройки
 * превращался бы в «тратить до цены одного отряда».
 */
export const calcConstructionPhaseCoins = (player, pendingBuildings) => (
  (player?.coins || 0) + (pendingBuildings || []).reduce((sum, building) => sum + (building.price || 0), 0)
);

/**
 * Монеты на начало хода стройки с тратами, которых нет в pending: политика
 * покупается до построек и списывает цену сразу. phaseStart — запись стратегии
 * бота {round, coins}, сделанная на первом тике хода стройки до покупки
 * политики (decideConstructionStep); запись другого раунда не в счет. Не меньше
 * текущих монет с ценами построек — резерв от этого только выше. Без записи —
 * прежний расчет: иначе политика и стройка тратили по минимальному бюджету
 * каждая (16 монет: политика 4 и стройка 4 — остается цена одного отряда)
 */
export const resolveConstructionPhaseCoins = (phaseStart, round, player, pendingBuildings) => {
  const phaseCoins = calcConstructionPhaseCoins(player, pendingBuildings);
  return phaseStart && phaseStart.round === round ? Math.max(phaseStart.coins, phaseCoins) : phaseCoins;
};
